import ACTIVITES_DATA from './activites-data';
import SMILEY_DATA from './smiley-data';
import TRAVEL_DATA from './travel-data';
import SYMBOLS_DATA from './symbols-data';

export const EMOJI_MAP = {
  ...SMILEY_DATA,
  ...ACTIVITES_DATA,
  ...TRAVEL_DATA,
  ...SYMBOLS_DATA,
};

export const EMOJI_DATA = {
  smileys_people: {
    type: 'group',
    label: 'Smileys & People',
    items: Object.keys(SMILEY_DATA),
  },
  activity: {
    type: 'group',
    label: 'Activity',
    items: Object.keys(ACTIVITES_DATA),
  },
  travel_places: {
    type: 'group',
    label: 'Travel & Places',
    items: Object.keys(TRAVEL_DATA),
  },
  //   objects: {
  //     type: 'group',
  //     label: 'Objects',
  //     items: [],
  //   },
  symbols: {
    type: 'group',
    label: 'Symbols',
    items: Object.keys(SYMBOLS_DATA),
  },
};

export default EMOJI_DATA;
